export default __webpack_public_path__ + "static/media/bourbon.8fdb94bf.svg";